// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-ia-c-enroll-lottery__start--pc{width:400px;height:256px;margin:30px auto 0;display:block}.plv-ia-c-enroll-lottery__start--pc-box{width:300px;height:300px;margin:30px auto 0}.plv-iar-enroll-lottery__on-lottery-modal{z-index:99}.plv-iar-enroll-lottery__on-lottery-modal .plv-iar-modal__main{top:50%;left:50%;bottom:initial;transform:translate(-50%, -50%);background-color:0,0,0,0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
